/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Vendor_Return_Not_ReadyInputs */

const en_error_vendor_return_not_ready = /** @type {(inputs: Error_Vendor_Return_Not_ReadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The return cannot go to the warehouse yet: Tomorrow has to complete something on its side first. Try again later, or write to your contact at Tomorrow.`)
};

/**
* | output |
* | --- |
* | "The return cannot go to the warehouse yet: Tomorrow has to complete something on its side first. Try again later, or write to your contact at Tomorrow." |
*
* @param {Error_Vendor_Return_Not_ReadyInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_vendor_return_not_ready = /** @type {((inputs?: Error_Vendor_Return_Not_ReadyInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Vendor_Return_Not_ReadyInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_vendor_return_not_ready(inputs)
});